/* mailchimp module */

import uiRouter from '@uirouter/angularjs';

import { AppShellModule } from 'components/appShell/appShell.module';
import { AppsServiceModule } from '../../services/data/apps.service';

import './mailchimp.scss';

export const MailChimpModule = angular
    .module('app.pages.mailchimp', [
        uiRouter,
        AppShellModule,
        AppsServiceModule
    ]).config(($stateProvider) => {
        'ngInject';

        $stateProvider.state({
            parent: 'apps',
            name: 'mailchimp',
            url: '/mailchimp',
            component: 'appShell',
            params: {
                queryString: null
            },
            resolve: {
                title: () => {
                    return 'Mailchimp';
                },
                trackingId: () => {
                    return 'Mailchimp';
                },
                src: ($stateParams, $sce, $q, appsService) => {
                    return $q.all([appsService.getApps(), appsService.getHmac(), appsService.getAppToken('hA1pajdjzlQeGnPggFWKDI-FHb_obphqrxMpwCQwLEQba-VWelW0vxjBHPtOYu_snOFU0WACbwwHauz31JSJIg')]) // eslint-disable-line max-len
                        .then(([apps, hmac, token]) => {
                            let uri = '';
                            apps.forEach((app) => {
                                if (app.sku === 'mailchimp') {
                                    uri = `${app.uri}?tenant=${hmac.tenant}&hmac=${hmac.hmac}&timestamp=${hmac.timestamp}&token=${token}`; //eslint-disable-line
                                    if ($stateParams.queryString) {
                                        uri = `${uri}&${$stateParams.queryString}`;
                                    }
                                }
                            });
                            return uri;
                        });
                }
            },
            data: {
                page: 'mailchimp'
            }
        });
    }).name;



// WEBPACK FOOTER //
// ./src/app/pages/mailchimp/mailchimp.module.js